import { render, staticRenderFns } from "./confirmDeleteModal.vue?vue&type=template&id=661121c2&scoped=true"
import script from "./confirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./confirmDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./confirmDeleteModal.vue?vue&type=style&index=0&id=661121c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661121c2",
  null
  
)

export default component.exports